export default __webpack_public_path__ + "static/media/basicuser.a1bbee73.svg";